import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-locale',
  templateUrl: './redirect-locale.component.html',
  styleUrls: ['./redirect-locale.component.css']
})
export class RedirectLocaleComponent implements OnInit {

  constructor() { }

  ngOnInit()
  {
    try
    {
      let lg = this.detectBrowsersLanguage();
      window.location.href = `${location.href}${lg}`; // /WhereToBuy/it
    }
    catch (e)
    {
      window.location.href = `${location.href}it`;
    }
  }

  detectBrowsersLanguage() : string
  {
    let lg = "it";
    if (typeof(navigator) !== "undefined" && typeof(navigator.language) !== "undefined")
    {
      let tmp = navigator.language;   // it-IT
      if (tmp !== "")
      {
        tmp = tmp.toLowerCase();      // it-it
        let i = tmp.indexOf("-");
        if (i !== -1)
          tmp = tmp.substring(0, i);  // it

        switch (tmp)
        {
          case "es":
            lg = "es";
          case "hu":
            lg = "hu";
          case "nl":
            lg = "nl";
          case "fr":
            lg = "fr";
          default:
            lg = "it";
        }
      }
    }
    return lg;
  }
}



// WEBPACK FOOTER //
// ./src/app/redirect-locale/redirect-locale.component.ts